import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import "./Navbar.css";

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen((current) => !current);
  };

  const closeMenu = () => {
    setIsOpen(false);
  };

  return (
    <nav className="navbar" aria-label="Main navigation">
      <div className="navbar-container container">
        <NavLink
          to="/"
          className="navbar-logo"
          onClick={closeMenu}
          aria-label="Sampanna Sanchar home"
        >
          <img src="/assets/images/logo.png" alt="Sampanna Sanchar Logo" />
          <span>Sampanna Sanchar</span>
        </NavLink>

        <div
          id="main-navigation"
          className={`navbar-menu ${isOpen ? "active" : ""}`}
        >
          <ul className="navbar-links">
            <li>
              <NavLink to="/" onClick={closeMenu} end>
                Home
              </NavLink>
            </li>

            <li>
              <NavLink to="/portfolio" onClick={closeMenu}>
                Portfolio
              </NavLink>
            </li>

            <li>
              <NavLink to="/about" onClick={closeMenu}>
                About
              </NavLink>
            </li>

            <li>
              <NavLink to="/services" onClick={closeMenu}>
                Services
              </NavLink>
            </li>

            <li>
              <NavLink to="/contact" onClick={closeMenu}>
                Contact
              </NavLink>
            </li>
          </ul>
        </div>

        <button
          type="button"
          className={`navbar-toggle ${isOpen ? "active" : ""}`}
          onClick={toggleMenu}
          aria-label={isOpen ? "Close navigation menu" : "Open navigation menu"}
          aria-expanded={isOpen}
          aria-controls="main-navigation"
        >
          <span className="bar"></span>
          <span className="bar"></span>
          <span className="bar"></span>
        </button>
      </div>
    </nav>
  );
};

export default Navbar;
